import { format, isFuture } from 'date-fns';
import React from 'react';
import { Link } from '@entur/typography';

export function mapEdgesToNodes(data) {
  if (!data.edges) return [];
  return data.edges.map((edge) => edge.node);
}

export function filterOutDocsWithoutSlugs({ slug }) {
  return (slug || {}).current;
}

export function filterOutDocsPublishedInTheFuture({ publishedAt }) {
  return !isFuture(publishedAt);
}

export function getBlogUrl(publishedAt, slug) {
  return `/blog/${format(publishedAt, 'YYYY/MM')}/${slug.current || slug}/`;
}

export function buildImageObj(source = { asset: {} }) {
  const imageObj = {
    asset: { _ref: source.asset._ref || source.asset._id },
  };

  if (source.crop) imageObj.crop = source.crop;
  if (source.hotspot) imageObj.hotspot = source.hotspot;

  return imageObj;
}

export function toPlainText(blocks) {
  if (!blocks) {
    return '';
  }
  return blocks
    .map((block) => {
      if (block._type !== 'block' || !block.children) {
        return '';
      }
      return block.children.map((child) => child.text).join('');
    })
    .join('\n\n');
}

/**
 * Detect special characters in a string, and create <Link> elements anywhere
 * a link is described. This is used to put anchors around words inside of i18n
 * messages, to avoid having to maintain raw html inside.
 *
 * linkMessage('This is a ((test|/home))') would generate:
 * ['This is a ', <Link to=/home>test</Link>]
 *
 * @param {string} content The string content to scan for anchor markers
 * @returns {Array} A mixed array of strings and JSX components
 */
export const linkMessage = (content) =>
  content.split(/(\(\(.*?\|?.*?\)\))/g).map((part, index) => {
    if (/^\(\(/.test(part)) {
      // if the part starts with '((' break it up into link parts
      const [anchor, href] = part.replace(/[()]+/g, '').split('|');
      return (
        <Link key={index} href={href.trim()}>
          {anchor.trim()}
        </Link>
      );
    }
    return part;
  });
